import React from 'react';
import { Route, Routes } from 'react-router-dom';
import WebScrapping from './webScrapping.tsx';
import PdfScrapping from './pdfScrapping.tsx';
import VideoScrapping from './videoScrapper.tsx';
import UrlGenerator from './UrlGenerator.tsx';
import ErrorPage from '../Shared/ErrorPage';
import Index from './index.tsx';
import AudioToText from './AudioToText.tsx';
import InstructionSet from '../InstructionSet/instructionset.tsx';
import EmbedChatbot from './EmbedChatbot.tsx';

const ScrapRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="web-scrap" element={<WebScrapping />} />
      <Route path="pdf-scrap" element={<PdfScrapping />} />
      <Route path="video-scrap" element={<VideoScrapping />} />
      <Route path="url-generator" element={<UrlGenerator />} />
      <Route path="audio-transcribe" element={<AudioToText />} />
      <Route path="instruction-set" element={<InstructionSet />} />
      <Route path="dynamic-chatbot" element={<EmbedChatbot />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

export default ScrapRouter;
